/**
 * Omezí číslo do zadaného uzavřeného intervalu.
 */
export const clamp = (number: number, lower: number, upper: number) => (
    Math.max(lower, Math.min(number, upper))
);

/*
 * Funkce porovná 2 čísla, zda se number1 přibližuje number2 v rámcí tolerance
 */
export const isClose = (number1: number, number2: number, tolerance: number) => {
    const absSum = Math.abs(number1 - number2);
    return (absSum <= tolerance);
};
